<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs3 />
      <v-flex xs6 class="font-number text-xs-center dayBorder">
        <v-card class="weekendBack elevation-0">
          <!-- LANGUAGE -->
          <v-card-title primary-title>
            <v-flex xs12>{{ $t("language") }}</v-flex>
            <v-flex xs12>
              <v-btn
                v-for="lang in languages"
                :key="lang"
                @click="setLanguage(lang)"
                fab
                large
                color="red darken-3">
                {{ lang }}
              </v-btn>
            </v-flex>
          </v-card-title>
          <!-- PC -->
          <v-card-title primary-title>
            <v-flex xs12>{{ $t("pcconnetion") }}</v-flex>
            <v-flex xs12>
              <v-btn
                color="teal"
                fab
                large
                dark
                @click="setAux()">
                <v-icon>laptop_mac</v-icon>
              </v-btn>
            </v-flex>
          </v-card-title>
          <!-- PROJECTOR -->
          <v-card-title primary-title>
            <v-flex xs12>{{ $t("projector") }}</v-flex>
            <v-flex xs12>
              <v-btn
                color="success"
                fab
                large
                dark
                @click="setProjectorOn()">
                <v-icon>videocam</v-icon>
              </v-btn>
              <v-btn
                color="error"
                fab
                large
                dark
                @click="setProjectorOff()">
                <v-icon>videocam_off</v-icon>
              </v-btn>
            </v-flex>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      languages: ["en", "fi", "se"]
    };
  },
  methods: {
    setLanguage(lang) {
      let l = lang;
      if (lang === "se") l = "sv";
      this.$i18n.locale = l;
      localStorage.setItem("virtual-app-l", l);
    },
    setAux() {
      this.$store.dispatch("controlDisplay", this.$store.getters.getDisplay.auxInput);
    },
    setProjectorOn() {
      this.$store.dispatch("controlDisplay", this.$store.getters.getDisplay.powerOn);
      this.$store.dispatch("setMessageWithTimeout", {
        message: "Turning projector on",
        time: this.$store.getters.getDisplayDriver.onTime * 1000
      });
    },
    setProjectorOff() {
      this.$store.dispatch("controlDisplay", this.$store.getters.getDisplay.powerOff);
      this.$store.dispatch("setMessageWithTimeout", {
        message: "Turning projector off",
        time: this.$store.getters.getDisplayDriver.offTime * 1000
      });
    }
  }
};
</script>

<style scoped>
.weekendBack {
  min-height: 100%;
  background: linear-gradient(#303030, #252525 20%, #252525 80%, #303030);
}

.dayBorder {
  border-right: 2px solid;
  border-left: 2px solid;
  border-image: linear-gradient(
    to top,
    #303030,
    #707070 30%,
    #707070 70%,
    #303030
  );
  border-image-slice: 1;
}
.btn--large {
  font-size: 30px !important;
}
</style>




// WEBPACK FOOTER //
// src/components/Settings.vue